// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleMetadataInputObjectives } from './moduleMetadataInputObjectives';
import type { ModuleMetadataInputLevels } from './moduleMetadataInputLevels';
import type { ModuleMetadataInputLearningHours } from './moduleMetadataInputLearningHours';
import type { ModuleMetadataInputLanguage } from './moduleMetadataInputLanguage';
import type { ModuleMetadataInputEcts } from './moduleMetadataInputEcts';

/**
 * Descriptive properties of a module
 */
export interface ModuleMetadataInput {
  description?: string;
  objectives?: ModuleMetadataInputObjectives;
  levels?: ModuleMetadataInputLevels;
  learningHours?: ModuleMetadataInputLearningHours;
  language?: ModuleMetadataInputLanguage;
  ects?: ModuleMetadataInputEcts;
}
